/**
 * Tour Registry
 * Central registry of all tour definitions
 */

import { TourDefinition } from './tour.types';

/**
 * Interactive step-by-step tours are OFF (2026-09-03). Sixteen tours / ~250
 * spotlight steps went stale as fast as the product moved; the welcome modal
 * with the full demo video is the onboarding now. The definitions stay so
 * the switch can come back, but nothing auto-starts, the help panels hide
 * the section, and startTour() is a no-op while this is false.
 */
export const INTERACTIVE_TOURS_ENABLED = false;
import { sidebarNavigationTour } from './sidebar-navigation.tour';
import { navbarTour } from './navbar.tour';
import { dashboardTour } from './dashboard.tour';
import { leadsTour } from './leads.tour';
import { leadDetailsTour } from './lead-details.tour';
import { dialerTour } from './dialer.tour';
import { communicationTour } from './communication.tour';
import { faxTour } from './fax.tour';
import { appointmentsTour } from './appointments.tour';
import { settingsTour } from './settings.tour';
import { agencyDashboardTour } from './agency-dashboard.tour';
import { leadAssignmentTour } from './lead-assignment.tour';
import { remindersTour } from './reminders.tour';
import { resourcesTour } from './resources.tour';
import { leaderboardTour } from './leaderboard.tour';
import { profileTour } from './profile.tour';

/**
 * Tour registry - all available tours
 * Key is the tour ID, value is the tour definition
 */
export const tourRegistry: Record<string, TourDefinition> = {
  // Navigation tours (start on dashboard, chain to page-specific tours)
  [sidebarNavigationTour.id]: sidebarNavigationTour,
  [navbarTour.id]: navbarTour,
  // Page-specific tours
  [dashboardTour.id]: dashboardTour,
  [leadsTour.id]: leadsTour,
  [leadDetailsTour.id]: leadDetailsTour,
  [dialerTour.id]: dialerTour,
  [communicationTour.id]: communicationTour,
  [faxTour.id]: faxTour,
  [appointmentsTour.id]: appointmentsTour,
  [settingsTour.id]: settingsTour,
  [agencyDashboardTour.id]: agencyDashboardTour,
  [leadAssignmentTour.id]: leadAssignmentTour,
  [remindersTour.id]: remindersTour,
  [resourcesTour.id]: resourcesTour,
  [leaderboardTour.id]: leaderboardTour,
  [profileTour.id]: profileTour,
};

/**
 * Get all tours for a specific page
 */
export function getToursForPage(page: string): TourDefinition[] {
  return Object.values(tourRegistry).filter((tour) => tour.page === page);
}

/**
 * Get all available tour IDs
 */
export function getAllTourIds(): string[] {
  return Object.keys(tourRegistry);
}

/**
 * Get tour by ID
 */
export function getTourById(id: string): TourDefinition | undefined {
  return tourRegistry[id];
}

/**
 * Get all tours (for settings page replay section)
 */
export function getAllTours(): TourDefinition[] {
  return Object.values(tourRegistry);
}

// Re-export types
export * from './tour.types';
